/**
 * COMMERCE-175A-R1 — localize delivery provider enums for customer UI.
 * Never show raw values like nova_poshta_warehouse.
 */
import type { StoreV2Lang } from "./store-v2-locale.js";

export function humanDeliveryMethodLabel(
  lang: StoreV2Lang,
  method: string | null | undefined,
): string {
  const en = lang === "en";
  const raw = String(method ?? "").trim().toLowerCase();
  if (!raw) return "";
  if (
    raw === "nova_poshta_warehouse" ||
    raw === "nova_poshta_branch" ||
    raw === "warehouse" ||
    raw === "branch" ||
    raw === "cargo_branch" ||
    raw.includes("warehouse") ||
    raw.includes("branch")
  ) {
    return en ? "Nova Poshta branch" : "Відділення Нової пошти";
  }
  if (
    raw === "nova_poshta_parcel_locker" ||
    raw === "parcel_locker" ||
    raw.includes("parcel_locker") ||
    raw.includes("postomat") ||
    raw.includes("locker")
  ) {
    return en ? "Nova Poshta parcel locker" : "Поштомат Нової пошти";
  }
  if (
    raw === "nova_poshta_courier" ||
    raw === "nova_poshta_address" ||
    raw === "courier" ||
    raw === "address" ||
    raw.includes("courier")
  ) {
    return en ? "Nova Poshta courier" : "Курʼєр Нової пошти";
  }
  if (raw.includes("pickup")) return en ? "Pickup" : "Самовивіз";
  if (raw.includes("digital")) return en ? "Digital delivery" : "Цифрова доставка";
  // Never echo raw snake_case enums to customers.
  if (/^[a-z0-9_]+$/.test(raw)) {
    return en ? "Delivery" : "Доставка";
  }
  // Free-text already human — keep short; never echo snake_case (handled above).
  return String(method ?? "").slice(0, 80).replace(/_/g, " ");
}

export function isRawDeliveryEnum(value: string | null | undefined): boolean {
  const raw = String(value ?? "").trim();
  return /^[a-z][a-z0-9_]*$/.test(raw) && raw.includes("_");
}
